import React, { useMemo, useState, useEffect } from 'react';
import styles from './style.module.scss';

const IGNORED_KEYS = new Set(['_id', '__v', 'createdAt', 'updatedAt', 'created_at', 'updated_at', 'po']);

const deepSearchSingleWord = (obj, word) => {
    if (typeof obj === 'string' || typeof obj === 'number') {
        return obj.toString().toLowerCase().includes(word);
    }

    if (Array.isArray(obj)) {
        return obj.some(item => deepSearchSingleWord(item, word));
    }

    if (typeof obj === 'object' && obj !== null) {
        return Object.entries(obj).some(([key, value]) => {
            if (IGNORED_KEYS.has(key)) {
                return false;
            }
            return deepSearchSingleWord(value, word);
        });
    }

    return false;
};

const deepSearch = (obj, searchTerm) => {
    if (!searchTerm) return true;
    
    // Parse search terms supporting quoted phrases
    const regex = /"([^"]+)"|'([^']+)'|(\S+)/g;
    const words = [];
    let match;
    while ((match = regex.exec(searchTerm)) !== null) {
        const token = match[1] || match[2] || match[3];
        if (token) {
            words.push(token.toLowerCase());
        }
    }

    if (words.length === 0) return true;
    return words.every(word => deepSearchSingleWord(obj, word));
};
function PoSearchBar({ setsearchMenu, searchMenu, SearchBars }) {
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            SearchBars();
        }
    };

    return (
        <div className={styles.search_view} style={{ position: 'relative' }}>
            <input
                type="search"
                placeholder="Search..."
                value={searchMenu}
                onChange={(e) => {
                    const val = e.target.value;
                    setsearchMenu(val);
                    if (!val.trim()) {
                        SearchBars('');
                    }
                }}
                onKeyDown={handleKeyDown}
            />

            <button
                type="button"
                className={searchMenu ? styles.existsearch : undefined}
                onMouseDown={(e) => {
                    e.preventDefault(); // Prevents input blur from swallowing the click
                }}
                onClick={() => {
                    SearchBars();
                }}
            >
                Search
            </button>
        </div>
    );
}

export default PoSearchBar;
